<template>
    <div class="game-peter-pan">
      
      <div class="game-header">
        <img class="app-logo" src="@/assets/logo.svg" />
        <img class="ride-logo" src="@/assets/rides/peterpan/logo.svg" />
      </div>

      <transition name="fade-ride-boarding">
        <div class="intro" v-if="onBoarding">
          <img class="hook" src="@/assets/rides/peterpan/hook.png" />
          <div class="card">
            <div class="container">
              <h2>Clochette a été enlevée!</h2>
              <p>
                La capitaine crochet a enlevé clochette !
                Aide peter pan et ses amis à la libérer en répondant aux différentes questions !
              </p>
            </div>
          </div>

          <button class="primary big-xl" v-on:click="startGame()">Commencer</button>
        </div>
      </transition>

      <transition name="fade-ride-boarding"> 
        <div class="card question with-duel" v-if="!onBoarding && !waiting">
          <div class="container">
            <h2>{{ this.question.question }}</h2>
            <ul>
              <li v-for="(answer, index) in this.question.answers" v-on:click="answering(index)">{{ answer }}</li>
            </ul>
          </div>
          <div class="duel">
            <img class="hook" src="@/assets/rides/peterpan/hook.png" />
            <img :src="'/static/img/characters/'+$store.state.character+'.png'" />
          </div>
          <transition name="fade">
            <div class="thumb-up-container" v-if="showThumbUp">
              <thumbUp />
              <div>
                <h2>Bonne réponse!</h2>
                <div class="stars-counter-small" style="margin: auto;"><img src="@/assets/starsPoint.svg" /> +100</div>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="error-container" v-if="showError">
              <div>
                <h2>Oh non...</h2>
                <p>Ce n'est pas la bonne réponse.</p>
                <button class="primary reverse" v-on:click="showError = false">Ré-essayer</button>
              </div>
            </div>
          </transition>

        </div>
      </transition>
      <transition name="fade-ride-boarding"> 
        <div class="timer-container" v-if="waiting">
          <bigBen />
          <div class="timer">
            prochaine question dans
            <div>{{ Math.floor(secondsRemaining / 60) }}:{{ (""+(secondsRemaining % 60)).padStart(2, "0") }}</div>
          </div>
        </div>
      </transition>

      <div class="background">
        <img class="city" src="@/assets/rides/peterpan/city.svg" />
        <img class="city" src="@/assets/rides/peterpan/city.svg" />
      </div>
    </div>
</template>

<script>
import thumbUp from '@/components/thumbUp'
import bigBen from '@/components/rides/peterPan/bigben'

export default {
  name: 'playPeterPan',

  components: {
    thumbUp,
    bigBen
  },

  data: function () {
    return {
      onBoarding: true,
      questions: [
        {
          question: 'Quel est le nom complet de l’attraction ?',
          answers: ['Peter Pan’s Flight', 'Peter Pan’s: new adventure'],
          correction: 0
        },
        {
          question: 'De quelles couleurs est le chapiteau que vous traversez dans la file d’attente ?',
          answers: ['vert et blanc', 'beige et bordeaux'],
          correction: 1
        },
        {
          question: 'Combien de lampadaires comptez-vous dans la file d’attente ?',
          answers: ['8', '6'],
          correction: 1
        },
        {
          question: 'Ouvrez bien les yeux! sur l’un des portillons de la file d’attente vous trouverez le nom du village du créateur de Peter Pan. Qui est-il ?',
          answers: ['Kirri Emuir', 'Jacob Grimm'],
          correction: 0
        },
        {
          question: 'Combien de fenêtres y a-t-il sur la bâtisse ?',
          answers: ['12', '14'],
          correction: 1
        },
        {
          question: 'Quelle ville allez-vous survoler durant votre aventure ?',
          answers: ['Paris', 'Londres'],
          correction: 1
        },
        {
          question: 'A bord de quel moyen de transport allez-vous survoler Londres dans Peter Pan’s Flight ?',
          answers: ['Un Gaillon pirate', 'Un tapis volant'],
          correction: 0
        },
        {
          question: 'Quel accessoire défensif possède Peter Pan ?',
          answers: ['Une dague', 'Un arc'],
          correction: 0
        }
      ],
      question: {},
      secondsRemaining: 0,
      showThumbUp: false,
      showError: false,
      waiting: false
    }
  },

  methods: {
    addTen: function () {
      var now = new Date()
      this.waitUntil = new Date(now.getTime() + 0.5 * 60000)
    },

    startTimer: function () {
      this.timer = setInterval(() => {
        var now = new Date()
        this.secondsRemaining = Math.round((this.waitUntil.getTime() - now.getTime()) / 1000)
        if (this.secondsRemaining < 0) {
          this.startRandomQuestion()
          clearInterval(this.timer)
          this.timer = undefined
        }
      }, 1000)
    },

    answering: function (a) {
      if (a === this.question.correction) {
        this.showThumbUp = true
        setTimeout(() => {
          this.waiting = true
          this.addTen()
          this.startTimer()
        }, 2000)
        this.$store.commit('gainStars', {ride: 'peterpan', stars: 100})
      } else {
        this.showError = true
      }
    },

    startRandomQuestion: function () {
      this.waiting = false
      this.onBoarding = false
      this.showThumbUp = false
      this.question = this.questions[Math.floor(Math.random() * this.questions.length)]
    },

    startGame: function () {
      this.startRandomQuestion()
    }
  },

  mounted: function () {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#080f22')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/rides/peterPan/game.vue